import React from "react";
import cx from "classnames";
import styles from "./Home.module.scss";
import { ButtonLinkInternal } from "components/Button";
import { checkInPrescriptions } from "features/routing/paths";
import {
  useCheckInPageTracking,
  useCheckInNavigationTracking,
  useCheckInTracking,
} from "features/checkIn/hooks/useCheckInTracking";

export const StartPrescriptions: React.FC = () => {
  useCheckInPageTracking({ step: 7, page: "home_prescriptions" });
  useCheckInNavigationTracking({ step: 7, page: "home_prescriptions" });
  const { trackCheckInEvent } = useCheckInTracking({
    step: 7,
    page: "home_prescriptions",
  });

  return (
    <div className={styles.currentAction}>
      <header className={styles.currentActionHeader}>
        <h2 className={styles.preheading}>Almost done,</h2>
        <h1 className={styles.heading}>How Rx works at MyEyeDr.</h1>
        <aside className={cx(styles.aside, styles.asideClipboardClock)}>
          Simple 1-Step Process
        </aside>
      </header>

      <div className={styles.actionText}>
        We&apos;ll provide easy access to any future prescriptions online and at
        the office.
      </div>

      <div className={styles.action}>
        <ButtonLinkInternal
          text="Continue"
          size="large"
          to={checkInPrescriptions()}
          onClick={() => trackCheckInEvent("continue")}
        />
      </div>
    </div>
  );
};
